import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { HttpClienteService } from '../http-cliente.service';

export const UNMISSABLES_GROUP = '2';
export const UNMISSABLES_LIMIT = 12;
export const ESSENTIALS_GROUP = '3';
export const ESSENTIALS_LIMIT = 15;

export interface EssentialsByGroupParams {
  code: string;
  sector: string;
  zone: string;
  schema: string;
  segment: string;
  group: string;
  limit: number;
}

export const mapEssentialToCard = (product: any) => ({
  typeCard: 2,
  discountNumber: Number.parseInt(product.discount) || 0,
  productImage: product.url || 'assets/image/search/no-image.svg',
  sku: product.sku,
  description: product.description,
  originalPrice: Number.parseFloat(product.salePrice),
  discountedPrice: null,
  count: 0,
  igv: Number.parseFloat(product.igv) || 0,
  discountType: product.discountType,
  buyUnd: product.buyUnd,
  brandName: product.brandName,
  baseUnd: product.buyBase,
  cashPrice: product.cashPrice,
  categoryName: product.categoryName,
  creditPrice: product.creditPrice,
  salePrice: product.salePrice,
  available: true,
  percep: false,
  perceptionFlag: 0,
  stock: false,
  suggestedQuantity: 0,
  categoryCode: product.categoryCode,
  group: product.group,
  isWebExclusive: product.isWebExclusive,
  mechanics: product.mechanics,
  priority: product.priority,
});

@Injectable({
  providedIn: 'root',
})
export class EssentialsService {
  private readonly url = environment.apiURL;
  constructor(private readonly _http: HttpClienteService) {}

  getEssentials(data: any) {
	//https://skynet-api-dev.azure-api.net/api/wcl-material/product-essential
    const query = `${this.url}/wcl-material/product-essential`;
    return this._http.post(query, data);
  }

  getEssentialsByGroup(params: EssentialsByGroupParams) {
    const queryParams = new HttpParams({ fromObject: { ...params } });
    return this._http.get(`${this.url}/wcl-material/product-essential?${queryParams.toString()}`);
  }

  validateEssentials(data: any) {
    //https://skynet-api-dev.azure-api.net/api/wcl-material/product-essential
      const query = `${this.url}/wcl-material/product-essential-validate`;
      return this._http.post(query, data);
    }
}
